import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Briefcase, Eye, X } from 'lucide-react';

const NotificationPopup = ({ onClose, notifications, markAsRead, loading }) => {
    const navigate = useNavigate();

    const handleAction = (notification) => {
        if (!notification.isRead) {
            markAsRead(notification._id);
        }

        if (notification.type === 'INVITE') {
            onClose(); // Close popup
            navigate(`/view-institution/${notification.sender._id}`);
        }
    };

    return (
        <div className="absolute right-0 top-12 w-[400px] max-h-[500px] overflow-y-auto bg-white rounded-xl shadow-2xl border border-gray-100 z-50 animate-in fade-in zoom-in-95 duration-200">
            <div className="sticky top-0 bg-white p-4 border-b flex items-center justify-between z-10">
                <h3 className="font-semibold text-gray-800">Notifications</h3>
                <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
                    <X size={18} />
                </button>
            </div>

            <div className="p-2">
                {loading && (
                    <div className="py-8 flex justify-center">
                        <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-500"></div>
                    </div>
                )}

                {!loading && notifications.length === 0 && (
                    <div className="py-8 text-center text-gray-500 text-sm">
                        No new notifications
                    </div>
                )}

                {!loading && notifications.map((notification) => (
                    <div
                        key={notification._id}
                        onClick={() => handleAction(notification)}
                        className={`
                            p-3 mb-2 rounded-lg cursor-pointer transition-colors
                            ${notification.isRead ? 'bg-white hover:bg-gray-50' : 'bg-blue-50 hover:bg-blue-100/50'}
                        `}
                    >
                        <div className="flex gap-3">
                            <div className={`mt-1 p-2 h-fit rounded-full flex-shrink-0 ${notification.type === 'INVITE' ? 'bg-purple-100 text-purple-600' : 'bg-blue-100 text-blue-600'}`}>
                                {notification.type === 'INVITE' ? <Eye size={16} /> : <Briefcase size={16} />}
                            </div>

                            <div className="flex-1">
                                <p className={`text-sm leading-snug ${notification.isRead ? 'text-gray-700' : 'text-gray-900 font-medium'}`}>
                                    {notification.message}
                                </p>
                                <div className="flex items-center gap-2 mt-1.5 text-xs text-gray-500">
                                    <span>{notification.sender?.name}</span>
                                    <span>•</span>
                                    <span>
                                        {new Date(notification.createdAt).toLocaleDateString(undefined, {
                                            month: 'short', day: 'numeric'
                                        })}
                                    </span>
                                </div>
                            </div>

                            {!notification.isRead && (
                                <div className="w-2 h-2 rounded-full bg-blue-500 mt-2"></div>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default NotificationPopup;
